var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.boxes, function(box, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("sales-grid-customer-box", {
              ref: "box",
              refInFor: true,
              attrs: {
                "default-customer-id": box.customer_id,
                "default-date": box.selected_date,
                "date-picker-placeholder": _vm.datePickerPlaceholder,
                "date-picker-placeholder-format":
                  _vm.datePickerPlaceholderFormat
              },
              on: { change: _vm.onChange }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-block alert-info fade in" }, [
      _c("span", [
        _c("i", { staticClass: "fa fa-info-circle" }),
        _vm._v(
          " Pour changer de date, les changements apportés doivent être sauvegardés ou annulés.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }